var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { forwardRef } from "react";
export const QuiCheckbox = forwardRef((_a, ref) => {
    var { disabled, size, className, invalid, indeterminate, label, gap, textSize, fullWidth, padding } = _a, otherProps = __rest(_a, ["disabled", "size", "className", "invalid", "indeterminate", "label", "gap", "textSize", "fullWidth", "padding"]);
    const cn = classNames(`qui-checkbox`, `qui-checkbox-primary`, `qui-checkbox-${size !== null && size !== void 0 ? size : "sm"}`, {
        "qui-invalid": invalid,
        "qui-checkbox-indeterminate": indeterminate,
    }, className);
    const lcn = classNames(`qui-interactive`, `qui-align-center`, `qui-${textSize !== null && textSize !== void 0 ? textSize : "text-sm"}`, padding && `qui-inset-${padding.replace(" ", "-")}`, {
        "qui-disabled": disabled,
        [`qui-flex-inline-${gap !== null && gap !== void 0 ? gap : "md"}`]: !fullWidth,
        [`qui-flex-h-${gap !== null && gap !== void 0 ? gap : "md"}`]: fullWidth,
        "qui-align-center": fullWidth,
        "qui-flex-h": fullWidth,
    });
    return (React.createElement("label", { style: { minWidth: "fit-content" }, className: lcn },
        React.createElement("input", Object.assign({ className: cn, ref: ref, disabled: disabled, type: "checkbox" }, otherProps)),
        label));
});
QuiCheckbox.displayName = "QuiCheckbox";
